import { render } from "./FooterMenu.vue?vue&type=template&id=a679a680&scoped=true"
const script = {}

import "./FooterMenu.vue?vue&type=style&index=0&id=a679a680&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a679a680"]])

export default __exports__